import { c as _c } from "react/compiler-runtime";
import PricePlanColumns from 'modules/profile/user-plan/components/price-plan-columns';
import PricePlanFeaturesColumn from 'modules/profile/user-plan/components/price-plan-features-column';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { getBillingPeriodFromSubscriptionPeriod } from 'modules/profile/user-plan/utils/price-plan-utils';
import React, { useEffect, useMemo, useState } from 'react';
import { RelativeTime } from 'shared/components/relative-time';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
export interface UserPlanTableProps {
  currentUserPlanData: UseUserPlanInterface;
}
const UserPlanTable = t0 => {
  const $ = _c(17);
  const {
    currentUserPlanData
  } = t0;
  let t1;
  if ($[0] !== currentUserPlanData.userPlans) {
    t1 = currentUserPlanData.userPlans.find(_temp);
    $[0] = currentUserPlanData.userPlans;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentPricePlan = t1;
  let t2;
  if ($[2] !== currentPricePlan?.price?.interval) {
    t2 = getBillingPeriodFromSubscriptionPeriod(currentPricePlan?.price?.interval || null) || BillingPeriodEnum.monthly;
    $[2] = currentPricePlan?.price?.interval;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [billingPeriod, setBillingPeriod] = useState(t2);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  let t3;
  let t4;
  if ($[4] !== currentPricePlan) {
    t3 = () => {
      if (currentPricePlan?.price) {
        setBillingPeriod(getBillingPeriodFromSubscriptionPeriod(currentPricePlan.price.interval) || BillingPeriodEnum.monthly);
      }
    };
    t4 = [currentPricePlan];
    $[4] = currentPricePlan;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== currentUserPlanData.nextBillingDate || $[8] !== t || $[9] !== user) {
    t5 = currentUserPlanData.nextBillingDate && user && <div className="text-text-primary py-3 pl-4 text-lg"><div className="flex items-center gap-1.5">{t("dashboard.settings.user_plan.next_billing_title")}<b className="text-text-primary"><RelativeTime time={currentUserPlanData.nextBillingDate} /></b></div></div>;
    $[7] = currentUserPlanData.nextBillingDate;
    $[8] = t;
    $[9] = user;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== billingPeriod || $[12] !== currentUserPlanData) {
    t6 = <div className="desktop:grid desktop:w-full desktop:grid-cols-[20%_80%] flex flex-1 flex-row justify-items-center"><PricePlanFeaturesColumn billingPeriod={billingPeriod} setBillingPeriod={setBillingPeriod} data={currentUserPlanData} /><PricePlanColumns currentUserPlanData={currentUserPlanData} billingPeriod={billingPeriod} /></div>;
    $[11] = billingPeriod;
    $[12] = currentUserPlanData;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="bg-bg-primary border-border-100 w-full overflow-hidden rounded-md border">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default UserPlanTable;
function _temp(pricePlan) {
  return pricePlan.currentUserPlan;
}